import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

function MonthlyEvolution({ dailySummary, t }) {
  if (!dailySummary || dailySummary.length === 0) return null;

  // Build chart data from daily summary - group by day
  const chartData = dailySummary
    .filter(d => d.total_cutting_time > 0 || d.total_machine_stopped > 0)
    .map(d => {
      const total = (d.total_cutting_time || 0) + (d.total_machine_stopped || 0) + (d.total_entre_cortes || 0);
      const eff = (d.total_cutting_time + d.total_machine_stopped) > 0 
        ? (d.total_cutting_time / (d.total_cutting_time + d.total_machine_stopped) * 100) : 0;
      return {
        date: d.date?.slice(5) || '', // MM-DD
        fullDate: d.date,
        corte: Math.round(d.total_cutting_time || 0),
        intra: Math.round(d.total_machine_stopped || 0),
        entre: Math.round(d.total_entre_cortes || 0),
        eficiencia: Math.round(eff * 10) / 10,
        velocidade: d.weighted_avg_speed || d.avg_real_speed || 0,
      };
    })
    .sort((a, b) => a.fullDate.localeCompare(b.fullDate));

  if (chartData.length === 0) return null;

  return (
    <div className={`${t.card} rounded-lg p-6`}>
      <h3 className={`text-sm font-semibold ${t.text} mb-4`} style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
        Evolução ({chartData.length} dias)
      </h3>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={chartData} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={t.key === 'dark' ? '#374151' : '#e5e7eb'} />
          <XAxis 
            dataKey="date" 
            tick={{ fill: t.key === 'dark' ? '#9ca3af' : '#6b7280', fontSize: 10 }}
            tickLine={false}
          />
          <YAxis 
            yAxisId="min"
            tick={{ fill: t.key === 'dark' ? '#9ca3af' : '#6b7280', fontSize: 10 }}
            tickLine={false}
            width={40}
            label={{ value: 'min', angle: -90, position: 'insideLeft', style: { fill: t.key === 'dark' ? '#6b7280' : '#9ca3af', fontSize: 10 } }}
          />
          <YAxis 
            yAxisId="pct"
            orientation="right"
            domain={[0, 100]}
            tick={{ fill: t.key === 'dark' ? '#9ca3af' : '#6b7280', fontSize: 10 }}
            tickLine={false}
            width={35}
            label={{ value: '%', angle: 90, position: 'insideRight', style: { fill: t.key === 'dark' ? '#6b7280' : '#9ca3af', fontSize: 10 } }}
          />
          <Tooltip 
            contentStyle={{ 
              background: t.key === 'dark' ? '#1f2937' : '#fff',
              border: `1px solid ${t.key === 'dark' ? '#374151' : '#e5e7eb'}`,
              borderRadius: '8px',
              fontSize: 12
            }}
            formatter={(value, name) => {
              if (name === 'Eficiência') return [`${value}%`, name];
              return [`${value} min`, name];
            }}
          />
          <Legend 
            wrapperStyle={{ fontSize: 10, paddingTop: 8 }}
          />
          <Line yAxisId="min" type="monotone" dataKey="corte" name="Corte" stroke="#10b981" strokeWidth={2} dot={false} />
          <Line yAxisId="min" type="monotone" dataKey="intra" name="Intra Marc." stroke="#ef4444" strokeWidth={2} dot={false} />
          <Line yAxisId="min" type="monotone" dataKey="entre" name="Entre Marc." stroke="#f59e0b" strokeWidth={1.5} dot={false} strokeDasharray="4 2" />
          <Line yAxisId="pct" type="monotone" dataKey="eficiencia" name="Eficiência" stroke="#8b5cf6" strokeWidth={2.5} dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default MonthlyEvolution;
